export default __webpack_public_path__ + "static/media/Shinra_tensei.83a62604.mp3";